import React from 'react';
import cn from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { Checkbox } from 'antd';
import {
  setWorkers,
  setCalendarData,
} from '../../store/actions/calendarActions';
import commonStyles from '../../Calendar.module.scss';

const ColorCheckbox = ({ entity, className, ...props }) => {
  const { workers, calendarData } = useSelector(
    (state) => state.newCalendarStore
  );

  const dispatch = useDispatch();

  const handleChange = (e) => {
    const clonedWorkers = workers.slice();

    const updatedWorker = clonedWorkers.find(
      (worker) => worker.id === entity.id
    );

    if (updatedWorker) {
      updatedWorker.checked = e.target.checked;

      const updatedCalendarData = calendarData.map((item) => {
        item.tasks.forEach((task) => {
          if (task.worker.id === updatedWorker.id) {
            task.visible = e.target.checked;
          }
        });

        if (item.daylongTasks) {
          item.daylongTasks.forEach((task) => {
            if (task.worker.id === updatedWorker.id) {
              task.visible = e.target.checked;
            }
          });
        }

        return item;
      });

      dispatch(setWorkers(clonedWorkers));
      dispatch(setCalendarData(updatedCalendarData));
    }
  };

  return (
    <Checkbox
      className={cn(
        commonStyles[`checkbox-${entity.index}`],
        commonStyles.checkbox,
        className
      )}
      onChange={handleChange}
      checked={entity.checked}
      {...props}
    />
  );
};

export default ColorCheckbox;
